var tema = localStorage.getItem("theme") || "light";

function setDefaultTheme() {
    let savedTheme = localStorage.getItem("theme");
    if (savedTheme) {
        setTheme(savedTheme);
    } else {
        const prefersDarkMode = window.matchMedia("(prefers-color-scheme: dark)").matches;
        const type = prefersDarkMode ? "dark" : "light";
        setTheme(type);
        saveSession(type);
    }
}

function saveSession(type) {
    axios.post("/api/setTheme", { theme: type });
}

setDefaultTheme();

function setTheme(theme) {
    tema = theme;
    document.documentElement.setAttribute("data-bs-theme", theme);
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("theme", theme);
}
